import Head from 'next/head';
import Image from 'next/future/image';
import Link from 'next/link';
import { CtaButton } from '@/components/Cta/Cta';
import iconCart from '@/public/icons/menu/cart.svg';
import i18n from '@/settings/i18n';
import { WebsiteSchema } from '../homepage/WebsiteSchema';

const t = i18n.init();

export default function EmptyCart() {
  return (
    <>
      <Head>
        <title>{t`Your Shopping Cart`}</title>
        <WebsiteSchema />
      </Head>
      <div className="reebelo-container pt-5 pb-10">
        <div className="mx-auto w-full max-w-[500px] py-12 text-center md:py-32">
          <div className="mx-auto mb-1 block w-10 xs:w-14">
            <Image alt="iconCart" src={iconCart} className="w-full" />
          </div>
          <h1 className="mb-3 text-base font-bold text-gray-700 xxs:text-lg md:text-2xl">
            {t`Your cart is empty`}
          </h1>
          <Link href={'/collections/smartphones'} passHref>
            <CtaButton
              variant="dark"
              className="mt-1 inline-block w-full xxs:w-3/5 sm:w-2/5"
            >{t`Let's go shopping`}</CtaButton>
          </Link>
        </div>
      </div>
    </>
  );
}
